<template>
    <span :style="{ height: computedHeight, width: computedWidth}" class="skeleton max-w-full" :class="roundedString"/>
</template>

<script>
import {formatDimension} from "@spoferan/spoferan-ts-core";
    import Roundable from "../../mixins/Roundable";

    export default {
        name: "Skeleton",

        mixins: [Roundable],

        props: {

            rounded: {
                type: Boolean,
                default: false
            },

            // The fixed width of the skeleton in pixels; when 'null', a random width between minWidth and maxWidth will be calculated
            width: {
                default: null,
                type: [String, Number],
            },

            // The min width of the skeleton in pixels
            minWidth: {
                type: [Number,String],
                default: 60
            },

            // The max width of the skeleton in pixels
            maxWidth: {
                type: [Number,String],
                default: 100
            },

            // The height of the skeleton
            // Defaults to the height of a paragraph
            height: {
                default: '16px',
                type: [String, Number],

            },
        },

        computed: {
            computedWidth() {
                return this.width ? formatDimension(this.width) : `${Math.floor((Math.random() * (parseFloat(this.maxWidth) - parseFloat(this.minWidth))) + parseFloat(this.minWidth))}px`;
            },

            computedHeight() {
                return formatDimension(this.height);
            }
        },
    }
</script>

<style>
.skeleton {
  display: block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: #DDDBDD;
}
.skeleton::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 5s infinite;
  content: "";
}
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>